module.exports = __webpack_public_path__ + "img/logo-text.5c79e6f.svg";